"use client";
import type { ApiErrorBody } from "./types";

export type ApiResult<T> = { ok: true; data: T } | { ok: false; status: number; error: ApiErrorBody };

/** ブラウザから API を呼ぶ（同じドメインの /api。クッキーは自動で付く） */
export async function call<T = unknown>(method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE", path: string, body?: unknown): Promise<ApiResult<T>> {
  try {
    const res = await fetch(path, {
      method,
      headers: body === undefined ? { accept: "application/json" } : { "content-type": "application/json", accept: "application/json" },
      body: body === undefined ? undefined : JSON.stringify(body),
      credentials: "same-origin",
    });
    const data = (await res.json().catch(() => ({}))) as T & ApiErrorBody;
    if (res.ok) return { ok: true, data };
    if (data?.error === "admin_logged_in") window.location.href = "/admin-notice";
    return { ok: false, status: res.status, error: data ?? {} };
  } catch {
    return { ok: false, status: 0, error: { message: "通信できませんでした。電波の良いところで、もう一度お試しください。" } };
  }
}

/** エラーの文言（API が返した文言を優先） */
export function errorText(e: ApiErrorBody, fallback = "うまくいきませんでした。もう一度お試しください。"): string {
  return e.message ?? fallback;
}
